/**
 * @generated SignedSource<<8c0eecc0f0f9591446f40a5dbc504976>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type IssueStateReason = "COMPLETED" | "NOT_PLANNED" | "REOPENED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type IssueActionsState$data = {
  readonly id: string;
  readonly state: IssueState;
  readonly stateReason: IssueStateReason | null;
  readonly " $fragmentType": "IssueActionsState";
};
export type IssueActionsState$key = {
  readonly " $data"?: IssueActionsState$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueActionsState">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueActionsState",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stateReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "51108559a051112bf173311ca9675951";

export default node;
